module.exports = __webpack_public_path__ + "static/media/yale.c867533d.png";